module.exports = __webpack_public_path__ + "72854e70a2b696b41f073d39c7351b40.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/sehnsuchtslieder.jpg
// module id = 909
// module chunks = 0